export default __webpack_public_path__ + "static/media/ecuador-flag.ef5949ca.jpeg";